/* eslint-disable no-restricted-globals */
import * as React from 'react';
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from '@progress/kendo-react-inputs';
import { Reports } from "./ReportData";
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import  ReportViewer  from '../components/ReportViewer';
import configData from "../config.json";
import { GetSession, GetToken, GetUserName } from '../components/Session';
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { GetPermissions } from '../components/Options';
import { GetCloudLogin } from "../WeighBridge/Helpers";
import { useNavigate } from "react-router-dom";
import { filterBy } from "@progress/kendo-data-query";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

const SimpleReports = () => {
    const navigate = useNavigate()
    if (localStorage.getItem("userid") === null) navigate("/logout");
    const [permissions, setPermissions] = React.useState(null);
    const [company, setCompany] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [url, setUrl] = React.useState(configData.SERVER_URL);
    const [token, setToken] = React.useState(GetToken());
    const [showDates, setShowDates] = React.useState(true);
    const [showOptions, setShowOptions] = React.useState(false);
    const [allReports, setAllReports] = React.useState(Reports);
    const [siteName, setSiteName] = React.useState("");
    const [activeSites, setActiveSites] = React.useState("All Sites");
    const [activeSitesSum, setActiveSitesSum] = React.useState("All Sites");
    const [activeCust, setActiveCust] = React.useState("All Customers");
    const [activeCustSum, setActiveCustSum] = React.useState("All Customers");
    const [activeCustProd, setActiveCustProd] = React.useState("All Products");
    const [activeCustCust, setActiveCustCust] = React.useState("All Customers");
    const [activeSupp, setActiveSupp] = React.useState("All Suppliers");
    const [activeSuppSum, setActiveSuppSum] = React.useState("All Suppliers");
    const [activeCat, setActiveCat] = React.useState("All Waste Streams");
    const [activeCatSum, setActiveCatSum] = React.useState("All Waste Streams");
    const [activeSrc, setActiveSrc] = React.useState("All Sources");
    const [activeSrcSum, setActiveSrcSum] = React.useState("All Sources");
    const [activeDest, setActiveDest] = React.useState("All Destinations");
    const [activeDestSum, setActiveDestSum] = React.useState("All Destinations");
    const [activeProd, setActiveProd] = React.useState("All Products");
    const [activeProdSum, setActiveProdSum] = React.useState("All Products");
    const [activePProd, setActivePProd] = React.useState("All Products");
    const [activePDest, setActivePDest] = React.useState("All Destinations");
    const [activeCount, setActiveCounted] = React.useState("All Counted Items");
    const [activeCountedSum, setActiveCountedSum] = React.useState("All Counted Items");
    const [activeType, setActiveType] = React.useState("All Vehicle Types");
    const [activeTypeSum, setActiveTypeSum] = React.useState("All Vehicle Types");
    const [activeJob, setActiveJob] = React.useState("All Jobs");
    const [activeJobSum, setActiveJobSum] = React.useState("All Jobs");
    const [activeJJobs, setActiveJJobs] = React.useState("All Jobs");
    const [activeJProd, setActiveJProd] = React.useState("All Products");
    const [activeMJobs, setActiveMJobs] = React.useState("All Jobs");
    const [activeUser, setActiveUser] = React.useState("All Operators");
    const [activeUserSum, setActiveUserSum] = React.useState("All Operators");
    const [activeOJob, setActiveOJob] = React.useState("All Jobs");
    const [dialogError, setDialogError] = React.useState("");

    React.useEffect(() => {
        AddCustomReports();
        GetCloudLogin((cred) => {
            var baseUrl = configData.SERVER_URL;
            var token = GetToken();
            if (cred.token !== undefined && cred.token !== null && cred.token !== "") {
                baseUrl = GetSession().CloudURL;
                token = cred.token;
                setUrl(baseUrl);
                setToken(token);
            }
            var url = `${baseUrl}apiv7/sites?$filter=siteid eq 1 &search=ouiewq`;
            const init = {
                method: 'GET',
                accept: 'application/json',
                headers: { "Authorization": "Bearer " + token }
            }
            fetch(url, init).then(response => response.json()).then(d => {
                if (d !== undefined && d.length > 0) {
                    setCompany(d[0]['address1']);
                    setAddress(d[0]['address2']);
                }
            });
            url = `${baseUrl}apiv7/options`;
            fetch(url, init).then(response => response.json()).then(opt => {
                var sites = opt.sites;
                setSitesData(sites);
                setSiteValue(sites);
            });
        });
        GetPermissions(["ViewSettings"], setPermissions);
    }, []);

    const initialExpanded = Reports.reduce(
        (acc, cur) => ({
            ...acc,
            [cur.id]: false,
        }),
        {}
    );   
    const [expanded, setExpanded] = React.useState({
        ...initialExpanded,
        Brazil: true,
    });
    const onAction = React.useCallback(
        (id) => {
            setExpanded({
                ...expanded,
                [id]: !expanded[id],
            });
        },
        [expanded]
    );
    let dr;
    let dt = new Date();
    dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()) };
    //localStorage.setItem("ReportDates", JSON.stringify(dr));
    
    const [dateRange, setDateRange] = React.useState(dr);
    const [reportSelected, setReportSelected] = React.useState();
    const [reportName, setReportName] = React.useState();
    const [sitesData, setSitesData] = React.useState([]);
    const [loadTypeData, setLoadTypeData] = React.useState([]);
    const [directionData, setDirectionData] = React.useState([]);
    const [paymentData, setPaymentData] = React.useState([]);
    const [chargeData, setChargeData] = React.useState([]);
    const [vehicleData, setVehicleData] = React.useState([]);
    const [showDateRange, setShowDateRange] = React.useState(false);
    const rangeChanged = (event) => {
        const newRange = event.value;

        setDateRange(newRange);

        if (newRange.start && newRange.end) {
            setShowDateRange(false);
        }
    };

    const GenerateReport = (report) => {
        setReportSelected(report);
        DateSearch(report);
    }
    
    const [siteValue, setSiteValue] = React.useState([]);
    const onSiteChanged = (event) => { setSiteValue([...event.value]); };
    const [loadTypeValue, setLoadTypeValue] = React.useState([]);
    const onLoadTypeChanged = (event) => { setLoadTypeValue([...event.value]); };
    const [paymentValue, setPaymentValue] = React.useState([]);
    const onPaymentChanged = (event) => { setPaymentValue([...event.value]); };
    const [directionValue, setDirectionValue] = React.useState([]);
    const onDirectionChanged = (event) => { setDirectionValue([...event.value]); };
    const [vehicleValue, setVehicleValue] = React.useState([]);
    const onVehicleChanged = (event) => { setVehicleValue([...event.value]); };
    const [chargeValue, setChargeValue] = React.useState([]);
    const onChargeChanged = (event) => { setChargeValue([...event.value]); };
    const [productData, setProductData] = React.useState(null);
    const [filteredProductData, setFilteredProductData] = React.useState(null);
    const [productValue, setProductValue] = React.useState([]);
    const onProductChanged = (event) => { setProductValue([...event.value]); };
    const [customerData, setCustomerData] = React.useState(null);
    const [filteredCustomerData, setFilteredCustomerData] = React.useState(null);
    const [customerValue, setCustomerValue] = React.useState([]);
    const onCustomerChanged = (event) => { setCustomerValue([...event.value]); };
    const [jobData, setJobData] = React.useState(null);
    const [filteredJobData, setFilteredJobData] = React.useState(null);
    const [jobValue, setJobValue] = React.useState([]);
    const onJobChanged = (event) => { setJobValue([...event.value]); };
    const [categoryData, setCategoryData] = React.useState(null);
    const [filteredCategoryData, setFilteredCategoryData] = React.useState(null);
    const [categoryValue, setCategoryValue] = React.useState([]);
    const onCategoryChanged = (event) => { setCategoryValue([...event.value]); };
    const [sourceData, setSourceData] = React.useState(null);
    const [filteredSourceData, setFilteredSourceData] = React.useState(null);
    const [sourceValue, setSourceValue] = React.useState([]);
    const onSourceChanged = (event) => { setSourceValue([...event.value]); };
    const [destData, setDestData] = React.useState(null);
    const [filteredDestData, setFilteredDestData] = React.useState(null);
    const [destValue, setDestValue] = React.useState([]);
    const onDestChanged = (event) => { setDestValue([...event.value]); };
    const [vcData, setVcData] = React.useState(null);
    const [filteredVcData, setFilteredVcData] = React.useState(null);
    const [vcValue, setVcValue] = React.useState([]);
    const onVcChanged = (event) => { setVcValue([...event.value]); };
    const [truckData, setTruckData] = React.useState(null);
    const [filteredTruckData, setFilteredTruckData] = React.useState(null);
    const [truckValue, setTruckValue] = React.useState([]);
    const onTruckChanged = (event) => { setTruckValue([...event.value]); };
    const [userData, setUserData] = React.useState(null);
    const [filteredUserData, setFilteredUserData] = React.useState(null);
    const [userValue, setUserValue] = React.useState([]);
    const onUserChanged = (event) => { setUserValue([...event.value]); };

    const DateSearch = (report) => {
        let sd = dateRange.start === null ? new Date().toISOString() : dateRange.start.toISOString();
        let ed = dateRange.end === null ? new Date().toISOString() : dateRange.end.toISOString();
        let sites = "";
        if (siteValue !== undefined) {
            siteValue.forEach(x => sites += (sites !== "" ? "," : "") + x.id);
        }
        let act1 = GetActive(report, false, false);
        let inact1 = GetActive(report, true, false);
        let act2 = GetActive(report, false, true);
        let inact2 = GetActive(report, true, true);
        var url = `${configData.SERVER_URL}apiv7/transactionreports/gettransactionoptions?startdate=${sd}&enddate=${ed}&sites=${sites}&report=${report}&showactive=${act1}&showinactive=${inact1}&showactive2=${act2}&showinactive2=${inact2}`;
        const init = {
            method: 'GET',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init).then(response => response.json()).then(l => {
            if (l.count === 0) {
                setDialogError("There are no records for the selected date range");
            } else {
                setShowDates(false);
                setShowOptions(true);
                setChargeData(l.chargeTypes);
                setChargeValue(l.chargeTypes);
                setDirectionData(l.directions);
                setDirectionValue(l.directions);
                setPaymentData(l.paymentMethods);
                setPaymentValue(l.paymentMethods);
                setLoadTypeData(l.loadTypes);
                setLoadTypeValue(l.loadTypes);
                setVehicleData(l.vehicleTypes);
                setVehicleValue(l.vehicleTypes);
                setShowDates(false);
                setCustomerData(l.customers);
                setFilteredCustomerData(l.customers);
                setCustomerValue([]);
                setProductData(l.products);
                setFilteredProductData(l.products);
                setProductValue([]);
                setJobData(l.jobs);
                setJobValue([]);
                setFilteredJobData(l.jobs);
                setSourceData(l.sources);
                setFilteredSourceData(l.sources);
                setSourceValue([]);
                setDestData(l.destinations);
                setFilteredDestData(l.destinations);
                setDestValue([]);
                setVcData(l.vehicleConfigurations);
                setFilteredVcData(l.vehicleConfigurations);
                setVcValue([]);
                setTruckData(l.vehicles);
                setFilteredTruckData(l.vehicles);
                setTruckValue([]);
                setUserData(l.users);
                setFilteredUserData(l.users);
                setUserValue([]);
                setCategoryData(l.productCategories);
                setFilteredCategoryData(l.productCategories);
                setCategoryValue([]);
            }
        });
    }

    const Restart = () => {
        setReportName("");
        setShowDates(true);
        setShowOptions(false);
    }

    const ShowReport = () => {
        // for all entities that are empty, select all the available values. If left empty, all will be used (active and inactive) even though only some selected
        if (customerValue !== null && customerValue.length === 0) setCustomerValue(customerData);
        if (productValue !== null && productValue.length === 0) setProductValue(productData);
        if (jobValue !== null && jobValue.length === 0) setJobValue(jobData);
        if (sourceValue !== null && sourceValue.length === 0) setSourceValue(sourceData);
        if (destValue !== null && destValue.length === 0) setDestValue(destData);
        if (vcValue !== null && vcValue.length === 0) setVcValue(vcData);
        if (truckValue !== null && truckValue.length === 0) setTruckValue(truckData);
        if (userValue !== null && userValue.length === 0) setUserValue(userData);
        if (categoryValue !== null && categoryValue.length === 0) setCategoryValue(categoryData);
        if (siteName !== "" && reportSelected === "Custom")
            setReportName(siteName + reportSelected);
        else
            setReportName(reportSelected);
    }

    const filtercustChange = (event) => {
        setFilteredCustomerData(filterBy(customerData.slice(), event.filter));
    };
    const filterProductChange = (event) => {
        setFilteredProductData(filterBy(productData.slice(), event.filter));
    };
    const filterJobChange = (event) => {
        setFilteredJobData(filterBy(jobData.slice(), event.filter));
    };
    const filterSourceChange = (event) => {
        setFilteredSourceData(filterBy(sourceData.slice(), event.filter));
    };
    const filterDestChange = (event) => {
        setFilteredDestData(filterBy(destData.slice(), event.filter));
    };
    const filterTruckChange = (event) => {
        setFilteredTruckData(filterBy(truckData.slice(), event.filter));
    };
    const filterUserChange = (event) => {
        setFilteredUserData(filterBy(userData.slice(), event.filter));
    };
    const filterCategoryChange = (event) => {
        setFilteredCategoryData(filterBy(categoryData.slice(), event.filter));
    };
    const filterVcChange = (event) => {
        setFilteredVcData(filterBy(vcData.slice(), event.filter));
    };

    const AddCustomReports = () => {
        let username = GetUserName();
        let sp = username.split('.');
        switch (sp[0]) {
            case "wagga":
                setAllReports([{
                    id: "Custom",
                    report: "Custom",
                }, ...Reports]);
                setSiteName("wagga_");
                break;
        }
    }

    const GetActive = (report, inact, second) => {
        switch (report) {
            case "TransactionBySite":
                if (inact) {
                    return activeSites === "All Sites" || activeSites === "Inactive Sites";
                } else {
                    return activeSites === "All Sites" || activeSites === "Active Sites";
                }
                break;
            case "TransactionBySiteSummary":
                if (inact) {
                    return activeSitesSum === "All Sites" || activeSitesSum === "Inactive Sites";
                } else {
                    return activeSitesSum === "All Sites" || activeSitesSum === "Active Sites";
                }
                break;
            case "TransactionByCustomer":
                if (inact) {
                    return activeCust === "All Customers" || activeCust === "Inactive Customers";
                } else {
                    return activeCust === "All Customers" || activeCust === "Active Customers";
                }
                break;
            case "TransactionByCustomerSummary":
                if (inact) {
                    return activeCustSum === "All Customers" || activeCustSum === "Inactive Customers";
                } else {
                    return activeCustSum === "All Customers" || activeCustSum === "Active Customers";
                }
                break;
            case "TransactionByProductCustomerSummary":
                if (second) {
                    if (inact) {
                        return activeCustProd === "All Products" || activeCustProd === "Inactive Products";
                    } else {
                        return activeCustProd === "All Products" || activeCustProd === "Active Products";
                    }
                } else {
                    if (inact) {
                        return activeCustCust === "All Customers" || activeCustCust === "Inactive Customers";
                    } else {
                        return activeCustCust === "All Customers" || activeCustCust === "Active Customers";
                    }
                }
                break;
            case "TransactionBySupplier":
                if (inact) {
                    return activeSupp === "All Suppliers" || activeSupp === "Inactive Suppliers";
                } else {
                    return activeSupp === "All Suppliers" || activeSupp === "Active Suppliers";
                }
                break;
            case "TransactionBySupplierSummary":
                if (inact) {
                    return activeSuppSum === "All Suppliers" || activeSuppSum === "Inactive Suppliers";
                } else {
                    return activeSuppSum === "All Suppliers" || activeSuppSum === "Active Suppliers";
                }
                break;
            case "TransactionByWasteStream":
                if (inact) {
                    return activeCat === "All Waste Streams" || activeCat === "Inactive Waste Streams";
                } else {
                    return activeCat === "All Waste Streams" || activeCat === "Active Waste Streams";
                }
                break;
            case "TransactionByWasteStreamSummary":
                if (inact) {
                    return activeCatSum === "All Waste Streams" || activeCatSum === "Inactive Waste Streams";
                } else {
                    return activeCatSum === "All Waste Streams" || activeCatSum === "Active Waste Streams";
                }
                break;
                break;
            case "TransactionBySource":
                if (inact) {
                    return activeSrc === "All Sources" || activeSrc === "Inactive Sources";
                } else {
                    return activeSrc === "All Sources" || activeSrc === "Active Sources";
                }
                break;
            case "TransactionBySourceSummary":
                if (inact) {
                    return activeSrcSum === "All Sources" || activeSrcSum === "Inactive Sources";
                } else {
                    return activeSrcSum === "All Sources" || activeSrcSum === "Active Sources";
                }
                break;
            case "TransactionByDestination":
                if (inact) {
                    return activeDest === "All Destinations" || activeDest === "Inactive Destinations";
                } else {
                    return activeDest === "All Destinations" || activeDest === "Active Destinations";
                }
                break;
            case "TransactionByDestinationSummary":
                if (inact) {
                    return activeDestSum === "All Destinations" || activeDestSum === "Inactive Destinations";
                } else {
                    return activeDestSum === "All Destinations" || activeDestSum === "Active Destinations";
                }
                break;
            case "TransactionByProduct":
                if (inact) {
                    return activeProd === "All Products" || activeProd === "Inactive Products";
                } else {
                    return activeProd === "All Products" || activeProd === "Active Products";
                }
                break;
            case "TransactionByProductSummary":
                if (inact) {
                    return activeProdSum === "All Products" || activeProdSum === "Inactive Products";
                } else {
                    return activeProdSum === "All Products" || activeProdSum === "Active Products";
                }
                break;
            case "TransactionByDestinationByProductSummary":
                if (second) {
                    if (inact) {
                        return activePProd === "All Products" || activePProd === "Inactive Products";
                    } else {
                        return activePProd === "All Products" || activePProd === "Active Products";
                    }
                } else {
                    if (inact) {
                        return activePDest === "All Destinations" || activePDest === "Inactive Destinations";
                    } else {
                        return activePDest === "All Destinations" || activePDest === "Active Destinations";
                    }
                }
                break;
            case "TransactionByCountedProduct":
                if (inact) {
                    return activeCount === "All Counted Items" || activeCount === "Inactive Counted Items";
                } else {
                    return activeCount === "All Counted Items" || activeCount === "Active Counted Items";
                }
                break;
            case "TransactionByCountedProductSummary":
                if (inact) {
                    return activeCountedSum === "All Counted Items" || activeCountedSum === "Inactive Counted Items";
                } else {
                    return activeCountedSum === "All Counted Items" || activeCountedSum === "Active Counted Items";
                }
                break;
            case "TransactionByVehicleType":
                if (inact) {
                    return activeType === "All Vehicle Types" || activeType === "Inactive Vehicle Types";
                } else {
                    return activeType === "All Vehicle Types" || activeType === "Active Vehicle Types";
                }
                break;
            case "TransactionByVehicleTypeSummary":
                if (inact) {
                    return activeTypeSum === "All Vehicle Types" || activeTypeSum === "Inactive Vehicle Types";
                } else {
                    return activeTypeSum === "All Vehicle Types" || activeTypeSum === "Active Vehicle Types";
                }
                break;
            case "TransactionByJob":
                if (inact) {
                    return activeJob === "All Jobs" || activeJob === "Inactive Jobs";
                } else {
                    return activeJob === "All Jobs" || activeJob === "Active Jobs";
                }
                break;
            case "TransactionByJobSummary":
                if (inact) {
                    return activeJobSum === "All Jobs" || activeJobSum === "Inactive Jobs";
                } else {
                    return activeJobSum === "All Jobs" || activeJobSum === "Active Jobs";
                }
                break;
            case "TransactionByProductJobSummary":
                if (second) {
                    if (inact) {
                        return activeJProd === "All Products" || activeJProd === "Inactive Products";
                    } else {
                        return activeJProd === "All Products" || activeJProd === "Active Products";
                    }
                } else {
                    if (inact) {
                        return activeJJobs === "All Jobs" || activeJJobs === "Inactive Jobs";
                    } else {
                        return activeJJobs === "All Jobs" || activeJJobs === "Active Jobs";
                    }
                }
                break;
            case "TransactionByJobByLoad":
                if (inact) {
                    return activeMJobs === "All Jobs" || activeMJobs === "Inactive Jobs";
                } else {
                    return activeMJobs === "All Jobs" || activeMJobs === "Active Jobs";
                }
                break;
            case "TransactionByOperator":
                if (inact) {
                    return activeUser === "All Operators" || activeUser === "Inactive Operators";
                } else {
                    return activeUser === "All Operators" || activeUser === "Active Operators";
                }
                break;
            case "TransactionByOperatorSummary":
                if (inact) {
                    return activeUserSum === "All Operators" || activeUserSum === "Inactive Operators";
                } else {
                    return activeUserSum === "All Operators" || activeUserSum === "Active Operators";
                }
                break;
            case "TransactionByOverweightJob":
                if (inact) {
                    return activeOJob === "All Jobs" || activeOJob === "Inactive Jobs";
                } else {
                    return activeOJob === "All Jobs" || activeOJob === "Active Jobs";
                }
                break;
        }
        return false;
    }

    return (
        <div>
            {!reportName && <div>
                {showDates && <h5 className="report-title">Click One of the Transaction Reports to View</h5>}
                {showDates && <div>
                    <div className="row Reportfillter">
                        <div className="col-md-4">
                            <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged} show={showDateRange} onFocus={() => setShowDateRange(true)} />
                        </div>
                        <div className='col-md-4'>
                            Site
                            <MultiSelect
                                data={sitesData}
                                onChange={onSiteChanged}
                                value={siteValue}
                                textField="name" dataItemKey="id"
                                placeholder="Please select ..."
                            />
                        </div>
                    </div>
                </div>}
                {showOptions && (
                    <div
                        style={{
                            height: "100vh",
                            width: "100vw",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            paddingTop: "60px",
                        }}
                    >
                        <div
                            style={{
                                maxWidth: "1200px",
                                width: "95%",
                                padding: "20px",

                                background: "rgba(255,255,255,0.08)",
                                borderRadius: "18px",
                                boxShadow: `0 20px 40px rgba(0,0,0,0.35),inset 0 1px 0 rgba(255,255,255,0.2)`,
                                backdropFilter: "blur(12px)",
                                border: "1px solid rgba(255,255,255,0.15)",
                                transform: "perspective(1000px)",
                            }}
                        >
                            <div className="row">

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Load Type</label>
                                    <MultiSelect
                                        data={loadTypeData}
                                        onChange={onLoadTypeChanged}
                                        value={loadTypeValue}
                                        placeholder="Select load type..."
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Payments</label>
                                    <MultiSelect
                                        data={paymentData}
                                        onChange={onPaymentChanged}
                                        value={paymentValue}
                                        placeholder="Select payments..."
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Direction</label>
                                    <MultiSelect
                                        data={directionData}
                                        onChange={onDirectionChanged}
                                        value={directionValue}
                                        placeholder="Select direction..."
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Vehicle Type</label>
                                    <MultiSelect
                                        data={vehicleData}
                                        onChange={onVehicleChanged}
                                        value={vehicleValue}
                                        placeholder="Select vehicle type..."
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="filter-label">Charge Type</label>
                                    <MultiSelect
                                        data={chargeData}
                                        onChange={onChargeChanged}
                                        value={chargeValue}
                                        placeholder="Select charge type..."
                                    />
                                </div>

                                {customerData && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label">
                                            {String(reportSelected).includes("Supplier")
                                                ? "Suppliers"
                                                : "Customers"}
                                        </label>
                                        <MultiSelect
                                            data={filteredCustomerData}
                                            onChange={onCustomerChanged}
                                            value={customerValue}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filtercustChange}
                                            filterable
                                            placeholder="Select..."
                                        />
                                    </div>
                                )}

                                {sourceData && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label">Sources</label>
                                        <MultiSelect
                                            data={filteredSourceData}
                                            onChange={onSourceChanged}
                                            value={sourceValue}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filterSourceChange}
                                            filterable
                                            placeholder="Select..."
                                        />
                                    </div>
                                )}

                                {destData && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label">Destinations</label>
                                        <MultiSelect
                                            data={filteredDestData}
                                            onChange={onDestChanged}
                                            value={destValue}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filterDestChange}
                                            filterable
                                            placeholder="Select..."
                                        />
                                    </div>
                                )}

                                {vcData && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label">Truck Configurations</label>
                                        <MultiSelect
                                            data={filteredVcData}
                                            onChange={onVcChanged}
                                            value={vcValue}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filterVcChange}
                                            filterable
                                            placeholder="Select..."
                                        />
                                    </div>
                                )}

                                {truckData && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label">
                                            {String(reportSelected).includes("Type")
                                                ? "Vehicle Type"
                                                : "Trucks"}
                                        </label>
                                        <MultiSelect
                                            data={filteredTruckData}
                                            onChange={onTruckChanged}
                                            value={truckValue}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filterTruckChange}
                                            filterable
                                            placeholder="Select..."
                                        />
                                    </div>
                                )}

                                {jobData && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label">Jobs</label>
                                        <MultiSelect
                                            data={filteredJobData}
                                            onChange={onJobChanged}
                                            value={jobValue}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filterJobChange}
                                            filterable
                                            placeholder="Select..."
                                        />
                                    </div>
                                )}

                                {userData && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label">Users</label>
                                        <MultiSelect
                                            data={filteredUserData}
                                            onChange={onUserChanged}
                                            value={userValue}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filterUserChange}
                                            filterable
                                            placeholder="Select..."
                                        />
                                    </div>
                                )}

                                {categoryData && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label">Waste Stream</label>
                                        <MultiSelect
                                            data={filteredCategoryData}
                                            onChange={onCategoryChanged}
                                            value={categoryValue}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filterCategoryChange}
                                            filterable
                                            placeholder="Select..."
                                        />
                                    </div>
                                )}

                                {productData && productData.length > 0 && (
                                    <div className="col-md-4 mb-3">
                                        <label className="filter-label">Products</label>
                                        <MultiSelect
                                            data={filteredProductData?.length > 0 ? filteredProductData : productData}
                                            onChange={onProductChanged}
                                            value={productValue}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filterProductChange}
                                            filterable
                                            placeholder="Select..."
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="row" style={{ marginTop: "40px" }}>
                                <div className="col-md-2">
                                    <Button themeColor="primary" onClick={ShowReport}>
                                        View Report
                                    </Button>
                                </div>

                                <div className="col-md-2">
                                    <Button onClick={Restart}>
                                        Back to list
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showDates && <div className="wrapper">
                    {allReports.map((item) => (
                        <ExpansionPanel
                            title={item.report}
                            expanded={expanded === item.id}
                            tabIndex={0}
                            key={item.id}

                            onAction={(event) => {
                                setExpanded(event.expanded ? "" : item.id);
                            }}
                        >
                            {expanded === "Custom" && item.id === "Custom" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport(item.id)} id={item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ListOfTransactions" && item.id === "ListOfTransactions" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="ReportButton"><Button onClick={() => GenerateReport("TransactionsList")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">Transaction List</Button>
                                                <Button style={{ marginLeft: "10px" }} onClick={() => GenerateReport("ManualList")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"> Manual List</Button>
                                                <Button style={{ marginLeft: "10px" }} onClick={() => GenerateReport("DeletedList")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"> Deleted List</Button>
                                            </div>
                                            <div className="ReportButton">
                                                <Button onClick={() => GenerateReport("VehicleTareDetailsList")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">Transaction Vehicle Tare Details List</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByDate" && item.id === "ByDate" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByPayment" && item.id === "ByPayment" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "BySite" && item.id === "BySite" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Sites", "Active Sites", "Inactive Sites"]} value={activeSites} onChange={(e) => setActiveSites(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Sites", "Active Sites", "Inactive Sites"]} value={activeSitesSum} onChange={(e) => setActiveSitesSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByCustomer" && item.id === "ByCustomer" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Customers", "Active Customers", "Inactive Customers"]} value={activeCust} onChange={(e) => setActiveCust(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Customers", "Active Customers", "Inactive Customers"]} value={activeCustSum} onChange={(e) => setActiveCustSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Customers", "Active Customers", "Inactive Customers"]} value={activeCustCust} onChange={(e) => setActiveCustCust(e.value)} /></div>
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activeCustProd} onChange={(e) => setActiveCustProd(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("TransactionByProductCustomerSummary")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} By Product</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "BySupplier" && item.id === "BySupplier" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Suppliers", "Active Suppliers", "Inactive Suppliers"]} value={activeSupp} onChange={(e) => setActiveSupp(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Suppliers", "Active Suppliers", "Inactive Suppliers"]} value={activeSuppSum} onChange={(e) => setActiveSuppSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByWasteStream" && item.id === "ByWasteStream" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Waste Streams", "Active  Waste Streams", "Inactive  Waste Streams"]} value={activeCat} onChange={(e) => setActiveCat(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Waste Streams", "Active  Waste Streams", "Inactive  Waste Streams"]} value={activeCatSum} onChange={(e) => setActiveCatSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "BySource" && item.id === "BySource" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Sources", "Active Sources", "Inactive Sources"]} value={activeSrc} onChange={(e) => setActiveSrc(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Sources", "Active Sources", "Inactive Sources"]} value={activeSrcSum} onChange={(e) => setActiveSrcSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByDestination" && item.id === "ByDestination" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Destinations", "Active Destinations", "Inactive Destinations"]} value={activeDest} onChange={(e) => setActiveDest(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Destinations", "Active Destinations", "Inactive Destinations"]} value={activeDestSum} onChange={(e) => setActiveDestSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByProduct" && item.id === "ByProduct" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activeProd} onChange={(e) => setActiveProd(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activeProdSum} onChange={(e) => setActiveProdSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Destinations", "Active Destinations", "Inactive Destinations"]} value={activePDest} onChange={(e) => setActivePDest(e.value)} /></div>
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activePProd} onChange={(e) => setActivePProd(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("TransactionByDestinationByProductSummary")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary By Destination {item.report}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByCountedProduct" && item.id === "ByCountedProduct" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Counted Items", "Active Counted Items", "Inactive Counted Items"]} value={activeCount} onChange={(e) => setActiveCounted(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Counted Items", "Active Counted Items", "Inactive Counted Items"]} value={activeCountedSum} onChange={(e) => setActiveCountedSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByTruckConfiguration" && item.id === "ByTruckConfiguration" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByVehicleType" && item.id === "ByVehicleType" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Vehicle Types", "Active Vehicle Types", "Inactive Vehicle Types"]} value={activeType} onChange={(e) => setActiveType(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4" style={{ marginTop: "20px" }}><DropDownList data={["All Vehicle Types", "Active Vehicle Types", "Inactive Vehicle Types"]} value={activeTypeSum} onChange={(e) => setActiveTypeSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByVehicle" && item.id === "ByVehicle" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByJob" && item.id === "ByJob" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeJob} onChange={(e) => setActiveJob(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeJobSum} onChange={(e) => setActiveJobSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeJJobs} onChange={(e) => setActiveJJobs(e.value)} /></div>
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Products", "Active Products", "Inactive Products"]} value={activeJProd} onChange={(e) => setActiveJProd(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("TransactionByProductJobSummary")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} By Product Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeMJobs} onChange={(e) => setActiveMJobs(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("TransactionByJobByLoad")} type={"submit"} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} MaxLoad Report</Button>                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByOperator" && item.id === "ByOperator" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Operators", "Active Operators", "Inactive Operators"]} value={activeUser} onChange={(e) => setActiveUser(e.value)} /></div>
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Operators", "Active Operators", "Inactive Operators"]} value={activeUserSum} onChange={(e) => setActiveUserSum(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Summary")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                            {expanded === "ByOverweight" && item.id === "ByOverweight" &&
                                <ExpansionPanelContent>
                                    <div className="content">
                                        <div className="row">
                                            <div className="col-md-4 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id)} id={"Transaction" + item.report} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View {item.report} Report</Button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginTop: "20px" }}><DropDownList data={["All Jobs", "Active Jobs", "Inactive Jobs"]} value={activeOJob} onChange={(e) => setActiveOJob(e.value)} /></div>
                                            <div className="col-md-3 ReportButton">
                                                <Button onClick={() => GenerateReport("Transaction" + item.id + "Job")} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">View Summary {item.report} By Job Report</Button>
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelContent>}
                        </ExpansionPanel>

                    ))}
                </div>}
            </div>}
            {reportName && <div> <Button style={{ marginLeft: "10px", marginTop: "30px" }} type={"submit"} onClick={() => Restart()}  themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"> Back To List</Button>
                <ReportViewer name={reportName} sites={siteValue} dateRange={dateRange} company={company} address={address} url={url} token={token} loadTypes={loadTypeValue}
                    payments={paymentValue} directions={directionValue} vehicles={vehicleValue} chargeTypes={chargeValue}
                    customers={customerValue} products={productValue} jobs={jobValue} trucks={truckValue} categories={categoryValue} sources={sourceValue} destinations={destValue}
                    users={userValue} vehicleConfigurations={vcValue}
                ></ReportViewer></div>}
            {dialogError !== "" && <Dialog title="No Records" onClose={() => setDialogError("")}>
                <div>{dialogError}</div>
                <DialogActionsBar>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={() => setDialogError("")}>Ok</button>
                </DialogActionsBar>
            </Dialog>}

        </div>
    );

}

export default SimpleReports;